import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-three-sixty-viewer-label',
  templateUrl: './three-sixty-viewer-label.component.html',
  styleUrls: ['./three-sixty-viewer-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeSixtyViewerLabelComponent {
  @Input() label: string;
}
